
import { createContext } from 'react';
import { RequestsContextType } from '../types';

export const RequestsContext = createContext<RequestsContextType | undefined>(undefined);
